import React, { Component } from 'react';
import { View, Text, TextInput, Button, ActivityIndicator, Picker, StyleSheet } from 'react-native';
import { Redirect } from 'react-router-dom';

import AuthContainer from '../../components/AuthContainer';
import * as ROUTES from '../../components/Navigation/routes';
import firebase, { storageRef, db } from '../../configs/firebase';

const URLExpression = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi);

const categories = [
    { name: "Funny", id: 1 },
    { name: "Space", id: 2 },
    { name: "Celebrities", id: 3 },
    { name: "Animals", id: 4 },
    { name: "Science", id: 5 },
    { name: "Lifestyle", id: 6 },
    { name: "Biology", id: 7 },
    { name: "Health", id: 8 },
    { name: "World", id: 9 },
    { name: "Sports", id: 10 },
    { name: "History", id: 11 },
    { name: "Society", id: 12 },
];

const IMAGE_FOLDER_NAME = 'posters';
const POSTER_COLLECTION_FOLDER_NAME = 'fpAppContent';

export default class EditPoster extends Component {

    constructor(props) {
        super(props);
        this.state = {
            posterId: String(this.props.match.params.posterid),
            posterTitle: '',
            posterExternalUrl: '',
            posterDescription: '',
            posterContentType: '',
            posterCategoryId: '',
            selectedFile: null,
            selectedFileName: null,
            uploadedFileUrl: '',
            newFileUrl: null,
            uploadProgress: 0,
            loader: false,
            loaded: false,
            goHome: false,
        }

        this._deleteUploadedFile = this._deleteUploadedFile.bind(this);
    }

    _getQueriedPoster() {
        db.collection(POSTER_COLLECTION_FOLDER_NAME).doc(this.state.posterId).get().then((doc) => {
            if (doc.exists) {
                console.log("Document data:", doc.data());
                const data = doc.data();
                this.setState({
                    posterTitle: data.title,
                    posterExternalUrl: data.infoUrl,
                    posterDescription: data.description,
                    posterContentType: data.contentType,
                    posterCategoryId: data.categoryId,
                    uploadedFileUrl: data.imgUrl,
                    loaded: true
                })
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
                alert('No such poster exists!')
                this.setState({
                    goHome: true
                })
            }
        }).catch(function (error) {
            console.log("Error getting document:", error);
            alert('Some error occured while fetching');
            this.setState({
                goHome: true
            })
        });

    }

    handleselectedFile = event => {

        if (window.confirm('This will replace the original file, are you sure ?')) {
            if (event.target.files[0].type === 'image/jpeg') {
                this.setState({
                    selectedFile: event.target.files[0],
                    selectedFileName: event.target.files[0].name,

                    //loader: true,
                }, () => {
                    //this._startUploadingFile();

                })
            } else {
                alert('Only .jpg or .jpeg files allowed');
            }
        }

    }

    async submit() {
        this.setState({ loader: true });

        if (this._validate().length !== 0) {
            alert("Error! \n" + this._validate().toString());
            this.setState({ loader: false })
        } else {
            console.log('1. Asking for update confirmation');
            if (window.confirm('Are you sure you want to update this poster ?')) {
                console.log('2.Confirmation received');
                console.log('3. Checking if file has to be replaced');

                if (this.state.selectedFileName && this.state.selectedFileName.length > 0) {//if selectedFileName is not null, it means user wants to replace the file
                    console.log('3.a.1. File replacement required, starting upload');
                    await this._startUploadingFile();
                    await this._deleteUploadedFile();
                    console.log('3.a.2. File upload successful, url', this.state.newFileUrl);
                }


                console.log('3.b.1. Starting to update the poster');
                await this._publishPoster()
                console.log('3.b.2. Update finished');
                alert('Success!!');
                this.setState({ loader: false, goHome: true })


            } else {
                this.setState({ loader: false })
            }
        }
    }

    _validate() {
        let errorFields = [];

        if (!this.state.posterTitle || this.state.posterTitle.trim().length === 0)
            errorFields.push('Poster Title can not be empty')

        if (this.state.posterExternalUrl.length > 0 && !this.state.posterExternalUrl.match(URLExpression))
            errorFields.push('Invalid Extermal URL format')

        if (!this.state.posterContentType)
            errorFields.push('Content Type field can not be empty')

        if (!this.state.posterCategoryId)
            errorFields.push('Category ID can not be empty')

        if (!this.state.posterDescription || this.state.posterDescription.trim().length === 0)
            errorFields.push('Poster description or keyword is compulsory')

        return errorFields;
    }


    async  _startUploadingFile() {
        // Create the file metadata
        const metadata = {
            contentType: 'image/jpeg'
        };

        let date = new Date();
        let fileName = '' + Math.floor(date.getTime() / 1000) + this.state.selectedFileName;
        fileName = fileName.replace(/\s+/g, '-').toLowerCase();
        this.setState({ selectedFileName: fileName })

        // Upload file and metadata to the object 'images/mountains.jpg'
        const uploadTask = await storageRef.child(IMAGE_FOLDER_NAME + '/' + fileName).put(this.state.selectedFile, metadata)
            .then(async (snapshot) => {
                await snapshot.ref.getDownloadURL().then((downloadURL) => {
                    this.setState({ newFileUrl: String(downloadURL) },
                        () => {
                            return true;
                        });
                });
            })
            .catch((err) => {
                console.log('Unable to upload file', err);
                return false;
            });

        /*  // Listen for state changes, errors, and completion of the upload.
         uploadTask.on('state_changed', // or 'state_changed'
             (snapshot) => {
                 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                 var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                 console.log('Upload is ' + progress + '% done');
                 this.setState({ uploadProgress: progress });
 
             }, (error) => {
 
                 // https://firebase.google.com/docs/storage/web/handle-errors
 
                 alert('Some error occured', String(error.code));
                 this.setState({ loader: false });
                 return false;
             }, () => {
                 // Upload completed successfully, now we can get the download URL
                 uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                     this.setState({ newFileUrl: String(downloadURL) },
                         () => {
                             return true;
                         });
                 });
             }); */
    }

    async _deleteUploadedFile() {
        const imageUrl = String(this.state.uploadedFileUrl);
        const fileName = imageUrl.match(/2F(.*?((jpeg)|(jpg)))/)[1];

        // Create a reference to the file to delete
        var desertRef = storageRef.child(IMAGE_FOLDER_NAME + '/' + fileName);
        // Delete the file
        await desertRef.delete().then(() => {
            // File deleted successfully
            console.log('Existing Image File deleted successfully!');
            console.log('3.a.3. Old File deletion finished');
            return true;
        }).catch((error) => {
            // Uh-oh, an error occurred!
            console.log('Some error occured deleting the file,\n' + String(error));
            return false;
        });

    }

    async _publishPoster() {

        let fileUrl = this.state.uploadedFileUrl;
        if (this.state.selectedFileName)
            fileUrl = this.state.newFileUrl

        const data = {
            contentType: this.state.posterContentType,
            categoryId: Number(this.state.posterCategoryId),
            title: this.state.posterTitle,
            description: this.state.posterDescription,
            imgUrl: String(fileUrl),
            infoUrl: String(this.state.posterExternalUrl)
        }

        console.log(data);
        const posterRef = db.collection(POSTER_COLLECTION_FOLDER_NAME).doc(this.state.posterId);

        await posterRef.update(data)
            .then(function () {
                console.log("Document successfully updated!");
                return true;
            })
            .catch(function (error) {
                // The document probably doesn't exist.
                console.error("Error updating document: ", error);
                alert('Some error occured updating the poster');
                return false;
            });
    }

    componentDidMount() {
        this._getQueriedPoster();
    }


    render() {
        if (!this.state.posterId || this.state.posterId.length === 0) {
            return <Redirect to={ROUTES.POSTERS} />
        }

        if (this.state.goHome) {
            return <Redirect to={ROUTES.POSTERS} />
        }
        return (
            <AuthContainer>
                {!this.state.loaded && <ActivityIndicator size="large" color="#0000ff" />}

                {this.state.loaded &&
                    <View style={{ alignItems: 'center', padding: 50 }}>
                        <Text style={styles.title}>Modify Poster</Text><hr />
                        <View>
                            <Text style={styles.greyLabel}>Poster Title:</Text>
                            <TextInput placeholder="Poster Title..." style={styles.uploadInputbox} value={this.state.posterTitle} onChangeText={(val) => {
                                this.setState({ posterTitle: val })
                            }} />

                            <Text style={styles.greyLabel}>External URL(optional):</Text>
                            <TextInput placeholder="External URL(optional)" style={styles.uploadInputbox} value={this.state.posterExternalUrl} onChangeText={(val) => {
                                this.setState({ posterExternalUrl: val })
                            }} />

                            <Text style={styles.greyLabel}>Keyword/Description:</Text>
                            <TextInput placeholder="Keywords or description" style={[styles.uploadInputbox, { height: 100 }]} value={this.state.posterDescription} onChangeText={(val) => { this.setState({ posterDescription: val }) }} multiline />

                            <View>
                                <Text style={styles.uploadLabel}>Upload Poster(2048x2048): </Text><br />

                                {(this.state.uploadedFileUrl && this.state.uploadedFileUrl.length > 0 && !this.state.selectedFileName) ? (
                                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <a href={this.state.uploadedFileUrl} target='_blank' rel='noopener noreferrer'>
                                            <img src={this.state.uploadedFileUrl} height="150" width="150" alt='' />
                                        </a>
                                    </View>
                                ) : null}


                                <Text style={styles.greyText}>{this.state.uploadProgress !== 0 ? this.state.uploadProgress + '% uploaded' : null}</Text><br />


                                {
                                    <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                                        <input type="file" onChange={this.handleselectedFile} />
                                    </View>
                                }

                            </View>


                            <View>
                                <Text style={styles.uploadLabel}>Content Type: </Text>
                                <Picker
                                    selectedValue={this.state.posterContentType}
                                    style={styles.uploadPicker}
                                    onValueChange={(itemValue, itemIndex) => {
                                        if (itemValue !== '0')
                                            this.setState({ posterContentType: itemValue })
                                    }
                                    }>
                                    <Picker.Item label="Picture Fact" value="picfact" />
                                </Picker>
                            </View>

                            <View>
                                <Text style={styles.uploadLabel}>Category ID: </Text>
                                <Picker
                                    selectedValue={this.state.posterCategoryId}
                                    style={styles.uploadPicker}
                                    onValueChange={(itemValue, itemIndex) => {
                                        if (itemValue !== '0')
                                            this.setState({ posterCategoryId: Number(itemValue) })
                                    }
                                    }>
                                    {categories.map(category => {
                                        return (
                                            <Picker.Item label={category.name} value={category.id} key={category.id} />
                                        )
                                    })}
                                </Picker>
                            </View>

                            <Button title="Update" onPress={() => this.submit()} disabled={this.state.loader} />
                            {this.state.loader ? <ActivityIndicator size="large" color="#0000ff" /> : null}
                        </View>
                    </View>
                }
            </AuthContainer>
        )
    }
}


const styles = StyleSheet.create({
    uploadInputbox: {
        borderBottomColor: '#5a80f8',
        borderBottomWidth: 2,
        fontSize: 20,
        marginBottom: 10
    },
    uploadPicker: {
        height: 30,
        marginBottom: 10
    },
    uploadLabel: {
        fontSize: 15
    },
    title: {
        fontSize: 28
    },
    greyLabel: {
        fontSize: 16,
        color: '#a1a6a9'
    },
    greyText: {
        color: '#a1a6a9',
        maxWidth: '100%'
    }
})